import dayjs from 'dayjs';

/**
 * Relative + absolute cache timestamp, e.g. "3 hours ago · 7 Sep 2026, 4:40 pm".
 * Empty / invalid → "No data".
 */
export function formatCacheAge(iso) {
  if (!iso) return 'No data';
  const date = dayjs(iso);
  if (!date.isValid()) return 'No data';
  return `${date.fromNow()} · ${date.format('D MMM YYYY, h:mm a')}`;
}

export function formatRowCount(n) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  return Number(n).toLocaleString();
}
